/*
 * Looks of a column. All of them stay subtle (the color is mixed into the neutral column
 * background) except the explicit "solid", "gradient" and "pattern" styles, which switch the
 * column's own chrome (header, empty text, footer) to a readable foreground. Cards are opaque
 * surfaces of their own and are never recolored by the column.
 */

/* Header: only the header strip is tinted. */
.frame[data-appearance='header'] .head,
.frame[data-adv-header] .head {
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  background: color-mix(in srgb, var(--column-header, var(--column-color)) 30%, transparent);
}

/* Border: a colored frame around the whole column. */
.frame[data-appearance='border'],
.frame[data-adv-border] {
  border: 2px solid var(--column-border, var(--column-color));
}

/* Accent: a stripe on top. */
.frame[data-appearance='accent'] {
  border-top-color: var(--column-border, var(--column-color));
}

/* Soft: a very light tint of the whole column. */
.frame[data-appearance='soft'] {
  background: color-mix(in srgb, var(--column-body, var(--column-color)) 12%, var(--color-column));
}

.frame[data-appearance='solid'] {
  background: var(--column-body, var(--column-color));
}

.frame[data-appearance='gradient'] {
  background-image: var(--column-gradient);
}

.frame[data-appearance='pattern'] {
  background-color: var(--column-pattern-bg, var(--color-column));
  background-image: var(--column-pattern);
  background-size: var(--column-pattern-size);
}

.frame[data-adv-body]:not([data-appearance='gradient']):not([data-appearance='pattern']) {
  background-color: var(--column-body);
}

/* A readable foreground for the parts drawn straight on a strongly colored column. */
.frame[data-fg] .chrome {
  --color-text: var(--column-fg);
  --color-text-muted: color-mix(in srgb, var(--column-fg) 78%, transparent);
  color: var(--column-fg);
}

/* Explicit text colors chosen in the appearance editor (after the derived foreground). */
.frame[data-title-color] .head h2 {
  color: var(--column-title-color);
}

.frame[data-text-color] .chrome {
  --color-text: var(--column-text-color);
  --color-text-muted: color-mix(in srgb, var(--column-text-color) 78%, transparent);

  color: var(--column-text-color);
}

/* A background picture: the chrome sits on a translucent panel so it stays readable. */
.frame[data-bg] {
  background-position: center;
  background-size: cover;
}

.frame[data-bg] .chrome {
  background: color-mix(in srgb, var(--color-column) 84%, transparent);
  border-radius: var(--radius-md);
}

/* ... and then the neutral text colors apply (undo a strong look's foreground). */
.frame[data-bg][data-fg] .chrome {
  --color-text: unset;
  --color-text-muted: unset;

  color: var(--color-text);
}

/* The card counter keeps its own pill on any column color. */
.frame[data-fg]:not([data-bg]) .badge {
  background: color-mix(in srgb, var(--column-fg) 22%, transparent);
  color: var(--column-fg);
}
